import { useLocalization } from "@i18n";
import { LoadingBlurDiv } from "@shared/components";

import { useLicenseAssignmentsUrlQuery } from "../api/license-assignments";
import { AdminLicenseAssignmentsTab } from "../components/organisms";

const AdminLicenseAssignmentsPage = () => {
  const { translate } = useLocalization();
  const { query, setFilters, resetFilters, currentFilters } =
    useLicenseAssignmentsUrlQuery();

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold">
          {translate("admin.licenseAssignments.page.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {translate("admin.licenseAssignments.page.subtitle")}
        </p>
      </header>

      <LoadingBlurDiv isLoading={query.isFetching}>
        <AdminLicenseAssignmentsTab
          items={query.data?.data ?? []}
          paginatedMeta={query.data?.meta}
          isLoading={query.isFetching}
          onFilter={setFilters}
          onClearFilter={resetFilters}
          initialFilters={currentFilters}
        />
      </LoadingBlurDiv>
    </div>
  );
};

export default AdminLicenseAssignmentsPage;
